import React, { useEffect, useState } from "react";
import api from "../../../adapters/axios";
import { FaEdit, FaTrash, FaCheck, FaTimes } from "react-icons/fa";
import './UserTags.css';

type TagOpt = { id: number; label: string };

export default function UserTagsManager() {
  const [tags, setTags] = useState<TagOpt[]>([]);
  const [editingId, setEditingId] = useState<number | null>(null);
  const [editLabel, setEditLabel] = useState("");

  const fetchTags = async () => {
    try {
      const res = await api.get("/user-tags", {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });
      const mappedTags = (res.data || []).map((tag: any) => ({
        id: tag.id,
        label: tag.tagName,
      }));
      setTags(mappedTags);
    } catch (err: any) {
      console.error("Failed to fetch user tags", err.response || err);
      setTags([]);
    }
  };

  useEffect(() => {
    fetchTags();
  }, []);

  const handleEdit = (tag: TagOpt) => {
    setEditingId(tag.id);
    setEditLabel(tag.label);
  };

  const handleSave = async (id: number) => {
    if (!editLabel.trim()) return;
    try {
      await api.put(
        `/user-tags/${id}/update`,
        { tagName: editLabel },
        { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } }
      );
      fetchTags();
      setEditingId(null);
    } catch (err: any) {
      console.error("Failed to update tag", err.response || err);
      alert(err.response?.data?.error || "Failed to update tag");
    }
  };

  const handleDelete = async (id: number) => {
    if (!window.confirm("Are you sure you want to delete this tag?")) return;
    try {
      await api.delete(`/user-tags/${id}`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });
      fetchTags();
    } catch (err: any) {
      console.error("Failed to delete tag", err.response || err);
      alert(err.response?.data?.error || "Failed to delete tag");
    }
  };

  return (
    <div className="user-tags-manager">
      <h3>Manage Your Tags</h3>
      <div className="tags-list">
        {tags.length ? (
          tags.map(tag => (
            <div key={tag.id} className="tag-item">
              {editingId === tag.id ? (
                <input
                  value={editLabel}
                  onChange={(e) => setEditLabel(e.target.value)}
                  className="tag-input"
                />
              ) : (
                <span className="tag-label">{tag.label}</span>
              )}
              <div className="tag-actions">
                {editingId === tag.id ? (
                  <>
                    <button onClick={() => handleSave(tag.id)} className="btn-save"><FaCheck /></button>
                    <button onClick={() => setEditingId(null)} className="btn-cancel"><FaTimes /></button>
                  </>
                ) : (
                  <>
                    <button onClick={() => handleEdit(tag)} className="btn-edit"><FaEdit /></button>
                    <button onClick={() => handleDelete(tag.id)} className="btn-delete"><FaTrash /></button>
                  </>
                )}
              </div>
            </div>
          ))
        ) : (
          <div className="no-tags">No user tags found</div>
        )}
      </div>
    </div>
  );
}
